import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["schema", "onSchemaChange", "defaultSchema", "value", "onValueChange", "defaultValue", "types", "initialValue", "onClose", "enableCloseButton", "layout", "resultCount", "resultTotalCount"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import cloneDeep from 'clone-deep';
import { useCallback } from 'react';
import { useControlledState, useDerivedState, useRootRef } from '../../../../system';
import { FILTER_EMPTY, SCHEMA_EMPTY } from '../../constants';
import { useTypeIndex } from '../../hooks/useTypeIndex';
import { getConditionType as _getConditionType } from '../../utils/getConditionType';
import { FILTER_EDITOR_LAYOUT_HORIZONTAL } from '../constants';
export var useFilterEditor = function useFilterEditor(_ref, ref) {
  var schema = _ref.schema,
      onSchemaChange = _ref.onSchemaChange,
      defaultSchema = _ref.defaultSchema,
      value = _ref.value,
      onValueChange = _ref.onValueChange,
      defaultValue = _ref.defaultValue,
      types = _ref.types,
      initialValue = _ref.initialValue,
      onClose = _ref.onClose,
      enableCloseButton = _ref.enableCloseButton,
      layout = _ref.layout,
      resultCount = _ref.resultCount,
      resultTotalCount = _ref.resultTotalCount,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var innerRef = useRootRef(ref);

  var _useControlledState = useControlledState(defaultSchema, schema, onSchemaChange),
      _useControlledState2 = _slicedToArray(_useControlledState, 1),
      externalSchema = _useControlledState2[0];

  var typeIndex = useTypeIndex(types);

  var _useControlledState3 = useControlledState(defaultValue, value, onValueChange),
      _useControlledState4 = _slicedToArray(_useControlledState3, 2),
      externalValue = _useControlledState4[0],
      setExternalValue = _useControlledState4[1];

  var _useDerivedState = useDerivedState(function () {
    return cloneDeep(externalValue);
  }, [externalValue]),
      _useDerivedState2 = _slicedToArray(_useDerivedState, 2),
      internalValue = _useDerivedState2[0],
      setInternalValue = _useDerivedState2[1];

  var externalSchemaSafe = externalSchema && externalSchema.conditions ? externalSchema : SCHEMA_EMPTY;
  var internalValueSafe = internalValue && internalValue.conditions ? internalValue : FILTER_EMPTY;
  var onClearFilterButtonClick = useCallback(function () {
    setInternalValue(initialValue ? cloneDeep(initialValue) : FILTER_EMPTY);
  }, [initialValue]);
  var onApplyFilterButtonClick = useCallback(function () {
    setExternalValue(internalValue);

    if (onClose) {
      onClose();
    }
  }, [setExternalValue, internalValue, onClose]);
  var layoutHorizontal = layout === FILTER_EDITOR_LAYOUT_HORIZONTAL;
  var layoutVertical = layout !== FILTER_EDITOR_LAYOUT_HORIZONTAL;
  return {
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      ref: innerRef
    }),
    headerProps: {
      leftAligned: layoutHorizontal
    },
    conditionsProps: {
      vertical: layoutVertical
    },
    getConditionType: function getConditionType(condition) {
      return _getConditionType(condition, typeIndex);
    },
    getConditionProps: function getConditionProps(condition, path) {
      var conditionType = _getConditionType(condition, typeIndex);

      var conditionId = condition.id;
      var conditionValue = internalValueSafe.conditions.find(function (item) {
        return item.name === path;
      });

      var onConditionValueChange = function onConditionValueChange(newFieldValue) {
        var _a;

        var nextValue = cloneDeep(internalValue);
        nextValue = nextValue || {};
        nextValue.conditions = nextValue.conditions || [];
        var nextConditionValue = (_a = nextValue.conditions) === null || _a === void 0 ? void 0 : _a.find(function (conditionValueItem) {
          return conditionValueItem.name === path;
        });

        if (nextConditionValue) {
          if ('value' in newFieldValue) {
            nextConditionValue.value = newFieldValue.value;
          }

          if ('op' in newFieldValue) {
            nextConditionValue.op = newFieldValue.op;
          }
        } else {
          nextValue.conditions.push({
            id: conditionId,
            name: condition.name || conditionId,
            value: newFieldValue.value,
            op: newFieldValue.op
          });
        }

        setInternalValue(nextValue);
      };

      return {
        condition: condition,
        conditionType: conditionType,
        conditionValue: conditionValue,
        onConditionValueChange: onConditionValueChange
      };
    },
    schema: externalSchemaSafe,
    clearFilterButtonProps: {
      onClick: onClearFilterButtonClick
    },
    getApplyFilterButtonProps: function getApplyFilterButtonProps() {
      return {
        onClick: onApplyFilterButtonClick
      };
    },
    showCloseButton: enableCloseButton !== false,
    getCloseButtonProps: function getCloseButtonProps() {
      return {
        onClick: onClose
      };
    },
    showSeparatedActions: layoutVertical,
    showInlineActions: layoutHorizontal,
    showResultCount: resultCount !== undefined,
    showResultTotalCount: resultTotalCount !== undefined,
    resultCountFormatted: resultCount !== undefined ? new Intl.NumberFormat().format(resultCount) : 0,
    resultTotalCountFormatted: resultTotalCount !== undefined ? new Intl.NumberFormat().format(resultTotalCount) : 0,
    getResultCountProps: function getResultCountProps() {
      return {
        paragraph: true,
        medium: true,
        tag: 'div',
        color: 'neutral.04',
        marginTop: 6
      };
    }
  };
};